import FileLink from './FileLink';
import './FileLink.scss';

export default FileLink;
